import { render, staticRenderFns } from "./CardComplexBonus.vue?vue&type=template&id=237fdc1d&"
import script from "./CardComplexBonus.vue?vue&type=script&lang=js&"
export * from "./CardComplexBonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports